"use client";

import { DynamicMenuProvider } from "@/libs/contexts/DynamicMenuContext";
import { StoreInit } from "flowbite-react/store/init";
import { Provider } from "react-redux";
import { AuthProvider } from "../libs/providers/AuthProvider";
import SessionManager from "../libs/providers/SessionManager";
import { store } from "../libs/store/store.jsx";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <StoreInit dark={false} />
      <AuthProvider>
        <SessionManager>
          <DynamicMenuProvider>{children}</DynamicMenuProvider>
        </SessionManager>
      </AuthProvider>
    </Provider>
  );
}
